export default __webpack_public_path__ + "static/media/call_black.fcf04e38.svg";